import map from 'lodash/map'
import React, { FC } from 'react'
import styled from 'styled-components'

import AngleRightIcon from '@Assets/SVG/AngleRight'
import { SVGIcon } from '@Components/Icons'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { CustomerSupportData } from '@Globals/useCustomerSupportData'

const StyledItem = styled(Link)`
  padding: 10px 21px 10px 20px;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

const CustomerSupportLink: FC<CustomerSupportData> = (
  {
    destPageType,
    id,
    link,
    newTab,
    title,
  }: CustomerSupportData,
) => (
  <StyledItem
    key={id}
    event={new NavigationEvent({
      attributes: {
        dest_page_type: destPageType,
        dest_page_type_id: id,
        source_id: 'mobile_menu_bottom_links',
      },
      eventName: 'nav_link_click',
    })}
    href={link}
    rel={newTab ? 'noopener noreferrer' : undefined}
  >
    <span>{title}</span>
    <div>
      <SVGIcon icon={AngleRightIcon} size="12px" />
    </div>
  </StyledItem>
)

interface CustomerSupportMenuProps {
  customerSupportData: CustomerSupportData[]
}

export const CustomerSupportMenu: FC<CustomerSupportMenuProps> = (
  { customerSupportData }: CustomerSupportMenuProps,
) => (
  <div>
    {map(customerSupportData, CustomerSupportLink)}
  </div>
)
